import { combineReducers } from "redux";
import authReducer from "./Auth/auth.reducer";
import paymentReducer from "./ProcessPayment/processPayment.reducer";
import balanceReducer from "./Balance/balance.reducer";

const rootReducer = combineReducers({
  auth: authReducer,
  balances: balanceReducer,
  paymentMethod: paymentReducer
});

export default rootReducer;
